
import XLSX from 'xlsx';
const dateFormat = require('bmh/date-format');
const getUrl = require('baimahu/url-with-param');
import { Moment } from 'moment';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import qs from 'qs';
import { headersToCheck } from '../chuang/lib/upload-file';
import training_needs from "@/common/training_needs";

const _ = {
  pickBy: require('lodash/pick'),
  identity: require('lodash/identity')
};
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  get_follower_list: `${FCAPI}/boss/hundun/company/follower`,
  task_result: `${FCAPI}/boss/hundun/user/task/result`,
  down_err: `${FCAPI}/boss/hundun/user/task/err`,
  create_task: `${FCAPI}/boss/hundun/user/task`,
  importData: `${FCAPI}/boss/hundun/user/import`,
  get_list: `${FCAPI}/boss/hundun/user`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  change_log: `${FCAPI}/boss/hundun/user/log`,
  export: `${FCAPI}/boss/hundun/user/template`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  more_change: `${FCAPI}/boss/hundun/user/batch/0`,
  download_table: `${FCAPI}/boss/hundun/user/match/template?is_export=1`,
  user_match: `${FCAPI}/boss/hundun/user/match?is_export=1`,
  post_company: `${FCAPI}/boss/hundun/company`,
  serch_list: `${FCAPI}/boss/hundun/company`,
  serch_detailInfo: `${FCAPI}/boss/hundun/user/search/0`,
  batch_tag: `${FCAPI}/boss/hundun/user/batch/tag/0`
};
enum MatchType {
  match,
  match_success
}
interface form {
  input_type: number;
  is_keyman: number;
  wechat: string;
  connect_type: number;
  special_export: boolean; //特殊导出
  name: string; //用户名
  mobile: string; //手机号
  branch_id: number; //分社
  charge_teacher_id: number[]; //负责班主任
  classes: string; //班级
  online_status: number; //线上学籍
  offline_status: number; //线下学籍
  register_time: Moment[]; //注册时间
  cooperation: string[]; //合作
  identity: number; // 身份
  tag: number[]; // 标签
  tag_chaung: number[];
  follow_msg: string; // 跟进记录
  follow_status: string; // 跟进状态
  back_time: Moment[]; //回访时间
  tag_logic: string; // 标签逻辑
}
function initForm() {
  return {
    input_type: 1,
    connect_type: 1,
    wechat: '',
    special_export: false, //特殊导出
    name: '', //用户名
    mobile: '', //手机号
    income_range_begin: '',
    income_range_end: '',
    branch_id: 0, //分社
    charge_teacher_id: [], //负责班主任
    classes: '', //班级
    online_status: 0, //线上学籍
    is_keyman: 100,
    offline_status: 0, //线下学籍
    register_time: [], //注册时间
    cooperation: [], //合作
    identity: 0, // 身份
    tag: [0], // 标签
    tag_chaung: [0],
    tag_ai: [0],
    follow_msg: '', // 跟进记录
    follow_status: '0', // 跟进状态
    back_time: [], //回访时间
    learning_time: [], //最近学习时间
    add_time: [], //加进时间
    class_teacher_id: 0,
    admission_date: [],
    expiration: [],
    demand: '',
    corp_name: '',
    corp_position: '',
    industry: '',
    corp_intro: '',
    training_needs: [],
    tag_logic: 'or' // 标签逻辑
  };
}

function validateMapFormat() {
  return {
    full_name: {
      value: '',
      status: '',
      help: ''
    },
    is_tob: {
      value: 1,
      status: '',
      help: ''
    },
    present_head_id: {
      value: [],
      status: '',
      help: ''
    }
  };
}

function validateCompanyMapFormat() {
  return {
    contact_type: {
      value: '',
      status: '',
      help: ''
    },
    wechat: {
      value: '',
      status: '',
      help: ''
    },
    phone: {
      value: '',
      status: '',
      help: ''
    },
    branch_id: {
      value: '',
      status: '',
      help: ''
    },
    username: {
      value: '',
      status: '',
      help: ''
    },
    // present_head_id: {
    //   value: '',
    //   status: '',
    //   help: '',
    // },
    charge_teacher_id: {
      value: '',
      status: '',
      help: ''
    },
    user_teacher_id: {
      value: [],
      status: '',
      help: ''
    },
    is_keyman: {
      value: 1,
      status: '',
      help: ''
    }
  };
}

function validateStudentMapFormat() {
  return {
    branch_id: {
      value: '',
      status: '',
      help: ''
    },
    username: {
      value: '',
      status: '',
      help: ''
    },
    phone: {
      value: '',
      status: '',
      help: ''
    },
    charge_teacher_id: {
      value: [],
      status: '',
      help: ''
    },
    user_teacher_id: {
      value: [],
      status: '',
      help: ''
    }
  };
}

function initExportType() {
  return {
    input_type: 1,
    page_type: 1
  };
}
const Hundun = namespace('Hundun');
const branch_prd = ['用户名', '手机号', '负责班主任', '班主任', '跟进状态', '分配班级', '待解决问题', '能分享的', '能提供的', '行业', '公司名称', '职务', '备注', '微信号', '注册时间', '加进时间'];
const extra_prd = [
  '用户名',
  '手机号',
  '累计学习时长（小时）',
  '入学时间',
  '过期时间',
  '推荐入学人数',
  '行业',
  '公司名称',
  '企业规模（人）',
  '职务',
  '微信号',
  '归属地',
  '注册时间'
];
@Component
export default class HundunUserlist extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('cooperation_selects') cooperation_selects: any; //合作选项
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; // 线上学籍选项
  // @ts-ignore
  @Hundun.State('offline_students_status') offline_students_status: any; //线下学籍
  @Hundun.State('identity') identity: any; // 身份选项
  // @ts-ignore
  @Hundun.Action('FETCH_TEACHER') getTeacher: any;
  // @ts-ignore
  @Hundun.Action('FETCH_TAGS') getTags: any; //获取tag
  /* eslint-enable */
  get training_needs() {
    return training_needs;
  }
  get teacher_widthout_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  get tag_without_all() {
    let s = [...this.tag_list];
    s.pop();
    return s;
  }

  get follow_status_without_all() {
    return [
      {
        id: '1',
        value: '已加'
      },
      {
        id: '2',
        value: '团报'
      },
      {
        id: '3',
        value: '删'
      },
      {
        id: '4',
        value: '微信待通过'
      },
      {
        id: '5',
        value: '已发短信'
      },
      {
        id: '6',
        value: '微信非手机号'
      },
      {
        id: '7',
        value: '已电话沟通'
      },
      {
        id: '8',
        value: '活动分配'
      },
      {
        id: '99',
        value: '其他'
      }
    ];
  }
  classes: string[] = [];
  task_id = 0;
  stop_tag = 1; //
  confirm_loading = false;
  branch_list: any = []; // 导入弹框内的分社，为了显示请选择字样
  more_id = -1; //批量修改类型选择
  more_list: any[] = []; //批量修改二级数据选择列表
  more_change_form: any;
  tag_value = [];
  file_list: any = [];
  all_tag_list: any = []; //带全部的标签
  ai_tag_list: any = []; //智能标签
  user: any = {}; //添加标签的用户
  teacher_send_list = []; // 去除全部的老师列表
  percent = 0;
  more_change = [
    {
      id: 1,
      value: '负责班主任'
    },
    {
      id: 2,
      value: '班主任'
    },
    {
      id: 3,
      value: '跟进状态'
    },
    {
      id: 4,
      value: '分配班级'
    },
    {
      id: 5,
      value: '回访时间'
    },
    {
      id: 6,
      value: '标签'
    }
  ];
  form = initForm();
  //录入表单数据
  record_form = {
    username: '',
    phone: '',
    charge_teacher_id: -1,
    user_teacher: []
  };
  button_type = 1; // 复用弹框标志位
  branch_validate = {
    status: 'success',
    help: ''
  };
  form_record: any; //录入表单
  type_validate = {
    status: 'success',
    help: ''
  };
  export_info_type = 0;
  excel_file: any;
  //录入表单自定义
  record_validate = {
    username_validate: {
      status: 'success',
      help: ''
    },
    phone_validate: {
      status: 'success',
      help: ''
    }
  };
  show_stop_modal = false; //中止弹框
  upload_limit = 200; //每次请求上传条数
  input_data: any = [];
  select_row_data = []; //已选择的具体数据
  show_add_tag = false; // 添加标签弹框
  import_branch = -1; // 导入分社
  import_type = -1; // 导入模版
  is_loading = false;
  last_upload_data: any = [];
  log: string[] = []; //班主任备注
  more_form: any; //批量修改表单
  import_type_list = [
    // 导入模版
    {
      id: 1,
      value: '总部模版'
    },
    {
      id: 2,
      value: '分社模版'
    }
  ]; // 导入模版

  show_export_modal = false;
  locale = zhCN; //时间选择器汉化
  branch = 0;
  filter_teacher = [];
  followStatus_list = []; // 跟进状态
  table_data: any = {};
  select_row_key = [];
  is_show_uplodad_modal = false;
  match_modal_type = MatchType.match; //匹配模版弹窗状态
  matchType = MatchType; // 枚举匹配弹窗
  window = window as any;
  follower_list: any = [];
  exportType = initExportType();
  validate_map: any = validateMapFormat();
  validate_student_map: any = validateStudentMapFormat();
  validate_company_map: any = validateCompanyMapFormat();
  company_id = Symbol();
  contact_type = 0;
  is_keyman = 1;
  user_match = []; // 下载匹配结果数据
  export_input_is_disabled = true;
  batch_tag_dialog_visible = false; // 批量打标弹窗
  batch_dialog_tag = [];
  batch_dialog_tag_chuang = [];
  upload_file_list: any = [];
  batch_tag_file_list = [];
  connect_company_visible = false;
  relevance_list: any = [];
  tag_type = 1;
  handleDowadTemplate() {
    const header = [['姓名', '手机号', '负责班主任', '班主任', '跟进状态', '线上学籍', '行业', '公司名称', '职位', '公司简介']];
    const sheet_header = XLSX.utils.aoa_to_sheet(header);
    const sheet_body = this.user_match.map((item: any) => {
      return {
        姓名: item.name,
        手机号: item.mobile,
        负责班主任: item.charge_teacher_nickname,
        班主任: item.teacher_nickname,
        跟进状态: item.follow_status_name,
        线上学籍: item.online_status_name,
        行业: item.corp_industry,
        公司名称: item.corp_name,
        职位: item.position,
        公司简介: item.corp_intro
      };
    });
    const sheet = XLSX.utils.sheet_add_json(sheet_header, this.user_match, {
      skipHeader: true,
      origin: 'A2'
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, sheet, 'sheetName');
    XLSX.writeFile(wb, '匹配结果.xlsx');
  }
  async handleDownLoad() {
    const res = await this.$axios.get(API.download_table);
    if (res.data.status !== 200) {
      window.location.href = API.download_table;
    }
  }
  beforeCloseModal() {
    this.match_modal_type = this.matchType.match;
    this.input_data = [];
    this.file_list = [];
  }
  handleUploadFile() {
    console.log(123);
  }
  handleDownloadTemplate() {
    // window.location.href = `${FCAPI}/boss/hundun/user/match/template?is_export=1`
  }
  handleUploadFileModal() {
    this.is_show_uplodad_modal = true;
  }
  // 显示批量打标签弹窗
  handleBatchTag() {
    this.batch_tag_dialog_visible = true;
  }
  // 确认批量打标签
  async batchTagOk() {
    if (!(this.batch_tag_file_list.length > 0)) return this.$message.error('导入表格数据为空！');
    if (!(this.batch_dialog_tag.length > 0 || this.batch_dialog_tag_chuang.length > 0)) return this.$message.error('请选择标签！');
    const tag_id = (): any[] => {
      const tag_arr: any[] = [];
      if (this.batch_dialog_tag) {
        this.batch_dialog_tag.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      if (this.batch_dialog_tag_chuang) {
        this.batch_dialog_tag_chuang.forEach((element: any) => {
          tag_arr.push(element[element.length - 1]);
        });
      }
      return tag_arr.filter((item: any) => item != undefined);
    };
    const send_data = { mobile: this.batch_tag_file_list, tag_id: tag_id() };
    const res = await this.$axios.put(API.batch_tag, send_data);
    if (res.data.status !== 200) return this.$message.error(res.data.message);
    this.$message.success('导入成功！');
    this.batch_tag_dialog_visible = false;
    this.search();
  }
  // 取消批量打标签
  batchTagCancel() {
    this.batch_tag_dialog_visible = false;
  }
  // 批量打标签导入
  beforeFileUpload(file: File) {
    if (file.size > 1048576) {
      this.upload_file_list = [];
      return this.$message.error('文件大小不能超过10MB');
    }
    if (this.upload_file_list.length == 1) return this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
    this.upload_file_list.push(file);
    this.readExcel(file);
    return false;
  }
  // 批量打标签导入模板下载
  downloadBatchTagTemplate() {
    const header = { A1: { v: '手机号' } };
    const output = Object.assign({}, header);
    const ref = 'A1:A1';
    const wb = {
      SheetNames: ['批量打标签模板'],
      Sheets: {
        批量打标签模板: Object.assign({}, output, { '!ref': ref })
      }
    };
    XLSX.writeFile(wb, '批量打标签板.xlsx');
  }
  // 删除批量打标签文件
  removeFile(file: any) {
    this.upload_file_list = [];
  }
  // xlsx文件读取
  readExcel(file: any) {
    const fileReader = new FileReader();
    const header = { A1: { v: '手机号' } };
    fileReader.onload = async (ev) => {
      const pre_data = ev.target;
      let data;
      if (pre_data) {
        data = pre_data.result;
      }
      const workbook = await XLSX.read(data, { type: 'binary' });
      const name = workbook.SheetNames[0]; //取第一张表
      const sheet_data = workbook.Sheets[name];
      if (!headersToCheck(sheet_data, header)) {
        this.upload_file_list = [];
        return this.$message.error('文件表头错误!');
      }
      const ref: any = sheet_data['!ref'];
      const right_string: string = ref.split(':')[1];
      const max_number = right_string.replace(/[^0-9]/gi, '');
      const arr: any = [];
      for (let index = 2; index <= Number(max_number); index++) {
        if (sheet_data['A' + index]) arr.push(sheet_data['A' + index].v.toString());
      }
      this.batch_tag_file_list = arr;
    };
    fileReader.readAsBinaryString(file);
  }
  async confirmUploadFile() {
    if (this.match_modal_type === this.matchType.match) {
      const request_data = this.input_data.map((item: any) => {
        return item['手机号'];
      });
      const res = await this.$axios.post(API.user_match, {
        mobile: request_data
      });
      console.log(res);
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.match_modal_type = MatchType.match_success;
      this.user_match = res.data.data;
    } else {
      this.is_show_uplodad_modal = false;
    }

    this.match_modal_type = MatchType.match_success;
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  changeSelect(value: any) {
    this.form.charge_teacher_id = value;
  }
  @Watch('tag_list', { deep: true })
  changeTagList(newVal: any) {
    this.all_tag_list = [];
    // this.all_tag_list[0] = { id: 0, tag_name: '全部' };
    this.all_tag_list.push(...newVal);

    // 智能标签
    this.ai_tag_list = this.readAiTagList(newVal);

    console.log('all_tag_list', this.ai_tag_list);
  }

  @Watch('teacher_list', { deep: true })
  chanegeTeacher(newVal: any) {
    this.teacher_send_list = newVal.slice(1);
  }
  @Watch('record_form.phone', { deep: true }) //动态校验录入表单
  changePhone(newVal: any) {
    if (!/^1[3456789]\d{9}$/.test(newVal)) {
      this.record_validate.phone_validate.status = 'error';
      this.record_validate.phone_validate.help = '请输入正确格式手机号';
    } else {
      this.record_validate.phone_validate.status = '';
      this.record_validate.phone_validate.help = '';
    }
  }
  @Watch('record_form.username', { deep: true })
  changeUsername(newVal: any) {
    if (newVal) {
      this.record_validate.username_validate.status = '';
      this.record_validate.username_validate.help = '';
    }
  }

  readAiTagList(tree: any) {
    const result: any[] = [];
    tree.forEach((item: any) => {
      const newItem = { ...item };
      if (item.parent) {
        newItem.parent = this.readAiTagList(item.parent);
      }
      if (item.is_ai || newItem.parent?.length > 0) {
        result.push(newItem);
      }
    });
    return result;
  }

  //上传文件状态改变时出发，控制只能单独上传单文件
  handleChange(info: any) {
    // if (this.import_type === -1) {
    //   this.$message.error('请选择导入模版');
    //   this.file_list = [];
    //   return false;
    // }
    if (info.fileList.length == 0) {
      this.input_data = [];
      this.file_list = [];
    } else {
      this.file_list = [info.fileList[0]];
      const arr = this.file_list[0].name.split('.');
      if (arr[arr.length - 1] !== 'xlsx' && arr[arr.length - 1] !== 'xls') {
        this.file_list = [];
        this.input_data = [];
      }
    }
  }
  //同上
  beforeUpload(file: any) {
    const arr = file.name.split('.');
    if (arr[arr.length - 1] !== 'xlsx' && arr[arr.length - 1] !== 'xls') {
      this.file_list = [];
      this.input_data = [];
      this.$message.error('请上传xlsx或xls格式的文件');
      return false;
    }
    if (this.file_list.length > 0) {
      this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
      return false;
    }
    if (this.file_list.size > 1048576) {
      this.$message.error('文件大小不能超过10MB');
      return false;
    }
  }
  //excel内的诡异时间格式转换为时间戳
  floatToTimestamp(f: any) {
    const days = Math.floor(f);
    const date_time = new Date(1900, 0, days - 1).getTime();
    const time = (f - days) * 86400000 + 0.5;
    const timestamp = date_time + time;
    const res = parseInt(String(timestamp / 1000)) || 0;
    return res;
  }
  //五条并发请求（当前使用）
  async moreUpload(start: number, err: number, type: number, branch: number, task_id: any) {
    if (start > this.input_data.length) {
      if (this.stop_tag === 1) {
        const res: any = await this.$axios.get(API.task_result, {
          params: { task_id: this.task_id }
        });
        this.$message.success(`${this.input_data.length - res.data.data.fail_count}条导入成功,${res.data.data.fail_count}条导入失败`);
      } else {
        this.$message.error('取消上传');
      }
      //上传完成
      this.input_data = [];
      this.file_list = [];
      this.percent = 100;
      this.confirm_loading = false;
      this.show_export_modal = false;
      this.search(1);
      this.percent = 0;
      return;
    }
    if (err >= 3) {
      //出错三次
      this.moreUpload(start + this.upload_limit, 0, type, branch, task_id);
      return;
    }
    let errs = err; //当前上传错误次数
    let requests = [];

    let s = start; //开始标记为
    console.log(this.upload_limit);
    console.log(s);
    console.log(this.input_data);
    if (this.dataFormat(this.input_data.slice(s, s + this.upload_limit)) == false) {
      this.$message.error('表格格式有误');
      this.confirm_loading = false;
      return;
    } else {
      for (let i = 0; i < 5; i++) {
        let send_data: any = {
          branch_id: branch,
          template_type: type,
          data: this.dataFormat(this.input_data.slice(s, s + this.upload_limit)),
          task_id: task_id,
          is_cover: this.export_info_type
        };
        if (send_data.data.length !== 0) {
          requests.push(this.$axios.post(API.importData, send_data));
        }
        //生成五个请求
        s = s + this.upload_limit;
      }
      try {
        await Promise.all(requests);
        this.percent = Number(Number((s / this.input_data.length) * 100).toFixed(1));
        this.moreUpload(s, 0, type, branch, task_id);
      } catch (error) {
        errs++;
        this.moreUpload(s, errs, type, branch, task_id);
      }
    }
  }
  //请求递归单条轮训(当前未使用，可删除)
  async confirmUpload(start: number, err: number) {
    if (err > 3) {
      //如果单次数据出错超过三次以上则直接传入下一批
      this.confirmUpload(start + this.upload_limit, 0);
      return;
    }
    if (start >= this.input_data.length) {
      //传完则return；显示上传完成
      this.percent = 100;
      this.confirm_loading = false;
      this.show_export_modal = false;
      this.$message.success('上传成功');
      this.file_list = [];
      this.input_data = [];
      this.search(1);
      this.percent = 0;
      return;
    }
    let data = this.input_data.slice(start, start + this.upload_limit);
    const send_data = {
      branch_id: this.import_branch,
      template_type: this.import_type,
      data: this.dataFormat(data)
    };
    try {
      const res: any = await this.$axios.post(API.importData, send_data);
      if (res.status === 200) {
        this.percent = Math.floor(Number(((start + this.upload_limit) / Number(this.input_data.length)).toFixed(3)) * 100);
        this.confirmUpload(start + this.upload_limit, 0);
      } else {
        //如果数据有问题，按照异常来处理
        this.confirmUpload(start, err + 1);
      }
    } catch (error) {
      //异常处理，次数+1
      this.confirmUpload(start, err + 1);
    }
  }
  dataFormat(data: any) {
    let is_success: any = true;
    //数据转换
    if (data.length != 0) {
      console.log(this.import_type);
      if (this.import_type == 1) {
        if (
          '姓名' in data[0] &&
          '手机号' in data[0] &&
          '累计学习时长（小时）' in data[0] &&
          '入学时间' in data[0] &&
          '过期时间' in data[0] &&
          '推荐入学人数' in data[0] &&
          '最近学习时间' in data[0] &&
          '行业' in data[0] &&
          '企业全称' in data[0] &&
          '企业规模（人）' in data[0] &&
          '职位' in data[0] &&
          '微信号' in data[0] &&
          '归属地' in data[0] &&
          '注册时间' in data[0]
        ) {
          console.log(data[0]);
          is_success = true;
        } else {
          console.log(456);

          is_success = false;
        }
      } else {
        console.log(data);
        if (
          '姓名' in data[0] &&
          '注册时间' in data[0] &&
          '负责班主任' in data[0] &&
          '班主任' in data[0] &&
          '跟进状态' in data[0] &&
          '分配班级' in data[0] &&
          '待解决问题' in data[0] &&
          '能分享的' in data[0] &&
          '能提供的' in data[0] &&
          '行业' in data[0] &&
          '公司名称' in data[0] &&
          '年营收（万）' in data[0] &&
          '职务' in data[0] &&
          '备注' in data[0] &&
          '微信号' in data[0] &&
          '手机号' in data[0]
        ) {
          is_success = true;
        } else {
          is_success = false;
        }
      }
    }
    if (is_success) {
      let obj = JSON.parse(
        JSON.stringify(data)
          .replace(/用户名":/g, 'name":')
          .replace(/手机号":/g, 'mobile":')
          .replace(/累计学习时长（小时）":/g, 'learned_time":')
          .replace(/入学时间":/g, 'entered_time":')
          .replace(/过期时间":/g, 'expired_time":')
          .replace(/推荐入学人数":/g, 'recommend_count":')
          .replace(/最近学习时间":/g, 'learning_time":')
          .replace(/年营收（万）":/g, 'income":')
          .replace(/行业":/g, 'corp_industry":')
          .replace(/公司名称":/g, 'corp_name":')
          .replace(/企业规模（人）":/g, 'corp_scale":')
          .replace(/职务":/g, 'corp_position":')
          .replace(/微信号":/g, 'wechat":')
          .replace(/归属地":/g, 'location":')
          .replace(/注册时间":/g, 'register_time":')
          .replace(/跟进状态":/g, 'follow_status":')
          .replace(/企业全称":/g, 'corp_name":')
          .replace(/姓名":/g, 'name":')
          .replace(/职位":/g, 'corp_position":')
          .replace(/分配班级":/g, 'classes":')
          .replace(/待解决问题":/g, 'training_need":')
          .replace(/能分享的":/g, 'shareable":')
          .replace(/能提供的":/g, 'advantage":')
          .replace(/备注":/g, 'log":')
          .replace(/负责班主任":/g, 'charge_teacher":')
          .replace(/班主任":/g, 'teacher":')
          .replace(/加���时间":/g, 'add_time":')
      );
      obj.forEach((item: any) => {
        // if (item.register_time) {
        //   const s = item.register_time.toString().split('|');
        //   const real_time = new Date(s[s.length - 1]).getTime() / 1000;
        //   item.register_time = real_time ? real_time : 0;
        // } else {
        //   item.register_time = 0;
        // }
        if (item.register_time) {
          const real_time = this.floatToTimestamp(item.register_time);
          item.register_time = real_time ? real_time : 0;
        } else {
          item.register_time = 0;
        }
        if (item.entered_time) {
          const s = item.entered_time.toString().split('|');
          const real_time = new Date(s[s.length - 1].replace('dhy:', '')).getTime() / 1000;
          item.entered_time = real_time ? real_time : 0;
        } else {
          item.entered_time = 0;
        }
        if (item.expired_time) {
          const s = item.expired_time.toString().split('|');
          const real_time = new Date(s[s.length - 1].replace('dhy:', '')).getTime() / 1000;
          item.expired_time = real_time ? real_time : 0;
        } else {
          item.expired_time = 0;
        }
        if (item.learning_time) {
          const real_time = this.floatToTimestamp(item.learning_time);
          item.learning_time = real_time ? real_time : 0;
        } else {
          item.learning_time = 0;
        }
        if (item.add_time) {
          const real_time = this.floatToTimestamp(item.add_time);
          item.add_time = real_time ? real_time : 0;
        } else {
          item.add_time = 0;
        }
        if (item.corp_scale === '') {
          item.corp_scale = 0;
        }
        if (item.mobile === '') {
          item.mobile = 0;
        }
        if (item.learned_time === '') {
          item.learned_time = 0;
        }
        if (item.recommend_count === '') {
          item.recommend_count = 0;
        }
        if (item.income) {
          item.income = item.income * 10000;
        } else {
          item.income = 0;
        }
      });
      return obj;
    } else {
      return false;
    }
  }
  //上传文件
  uploadFile(file: any) {
    const sheet2JSONOpts = {
      /** Default value for null/undefined values */
      defval: '' //给defval赋值为空的字符串
    };
    new Promise((resolve: any) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target?.result;
        this.excel_file = XLSX.read(data, { type: 'binary' });
        const result: any = [];
        this.excel_file.SheetNames.forEach((sheetName: any) => {
          result.push({
            SheetNames: sheetName,
            sheet: XLSX.utils.sheet_to_json(this.excel_file.Sheets[sheetName], sheet2JSONOpts)
          });
        });
        resolve(result);
      };
      reader.readAsBinaryString(file.file);
    }).then((res: any) => {
      // let obj={
      //   name:file.file.name,
      //   status:'done'
      // }
      // this.file_list.push(obj);
      this.input_data = res[0].sheet;
      const header_list = Object.keys(this.input_data[0]);
      header_list.forEach((item: any, index: number) => {
        if (!item || item === '__EMPTY') {
          header_list.splice(index, 1);
        }
      });
      if (this.import_type === 2) {
        if (header_list.length !== 17) {
          this.input_data = [];
          this.file_list = [];
          this.$message.error('请选择格式正确的文件上传');
          return;
        }
        for (const obj in header_list) {
          if (branch_prd.indexOf(obj) !== -1) {
            this.input_data = [];
            this.file_list = [];
            this.$message.error('请选择格式正确的文件上传');
            return;
          }
        }
      }
      if (this.import_type === 1) {
        if (header_list.length !== 14) {
          this.input_data = [];
          this.file_list = [];
          this.$message.error('请选择格式正确的文件上传');
          return;
        }
        for (const obj in header_list) {
          if (extra_prd.indexOf(obj) !== -1) {
            this.input_data = [];
            this.file_list = [];
            this.$message.error('请选择格式正确的文件上传');
            return;
          }
        }
      }
      if (this.input_data.length > 8000 && this.is_show_uplodad_modal) {
        this.input_data = [];
        this.file_list = [];
        this.$message.error('上传名单不能超过8000条');
        return;
      }
      this.file_list[0].status = 'done';
    });
  }
  //批量修改中的回访时间选择
  // changeVisitTime() {}
  //修改编辑状态
  async editDetail(column: string, value: any, record: any) {
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    const send_data = {
      column: column,
      value: value
    };
    const res = await this.$axios.put(`${API.edit_user_detail}/${record.id}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.classes = [];
    this.search(this.table_data.current);
    if (res.data.status === 200) {
      this.$message.success('编辑成功');
    }
  }
  // async moreChange(id: any, column: string, value: any) {
  //   const send_data = {
  //     id: id,
  //     column: column,
  //     value: value
  //   };
  //   const res = await this.$axios.put(`${API.more_change}?menu_id=${(window as any).route_menu_id}`, send_data);
  //   this.select_row_key = [];
  //   this.search(this.table_data.current);
  //   if (res.data.status === 200) {
  //     this.$message.success('编辑成功');
  //   }
  // }
  async moreChange(
    id: any,
    column_teacher: string,
    column_teacher2: string,
    column_status: string,
    column_class: string,
    column_date: string,
    column_tag: any,
    column_tag_chuang: any
  ) {
    console.log(column_tag);

    const tag_arr = [];
    if (column_tag !== null) tag_arr.push(column_tag[column_tag.length - 1]);
    if (column_tag_chuang !== null) tag_arr.push(column_tag_chuang[column_tag_chuang.length - 1]);
    if (tag_arr.length > 2) return this.$message.error('编辑失败！');
    console.log(tag_arr);

    const send_data = {
      id: id,
      charge_teacher_id: column_teacher,
      teacher_id: column_teacher2,
      follow_status: column_status,
      classes: column_class,
      visit_time: column_date ? Math.floor((column_date as any).format('x') / 1000) : '',
      tag: tag_arr
    };
    const res = await this.$axios.put(`${API.more_change}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.data.data.status !== 200) return this.$message.error('编辑失败！');
    this.select_row_key = [];
    this.show_add_tag = false;
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
  }
  //下载导入错误信息
  async downError(id: number) {
    const url = getUrl(API.down_err, { template_type: id, is_export: 1 });
    this.$axios.get(url).then((res: any) => {
      if (res.data.status === 200) {
        this.$message.error(res.data.message);
      } else {
        window.location.href = url;
      }
    });
  }
  //修改批量修改选项类型
  changeMoretype(id: number) {
    this.more_change_form.resetFields(['second', 'visitTime']);
    this.more_id = id;
    switch (this.more_id) {
      case 1: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 2: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 3: {
        this.more_list = this.follow_status.slice(1);
        this.more_list.pop();
        break;
      }
      case 6:
        this.more_list = this.tag_list;
        break;
      default:
        break;
    }
  }
  //button为3、4、5的确认提交
  async submit() {
    if (this.button_type === 4) {
      if (this.import_type === -1) {
        this.$message.error('请选择模版类型');
        return;
      }
      const send_data: any = {
        type: +this.import_type,
        is_export: 1,
        tag_logic: this.form.tag_logic // Add this line to include tag logic
      };
      const url = getUrl(API.export, send_data);
      this.$axios.get(url).then((res: any) => {
        if (res.data.status === 200) {
          this.$message.error(res.data.message);
        } else {
          window.location.href = url;
        }
      });
    }
    if (this.button_type === 3) {
      this.more_form.validateFields((err: any, values: any) => {
        if (!err) {
          for (let item in values) {
            if (values[item] === undefined) {
              values[item] = null;
            }
          }
          // let date = new Date(values['date']);
          // let time1 = date.getTime();
          this.moreChange(this.select_row_key, values['teacher'], values['teacher2'], values['status'], values['class'], values['date'], values['tag'], values['tag_chuang']);
          // this.getMeunId();
          this.show_add_tag = false;
          this.select_row_key = [];
        }
      });
      // this.more_change_form.validateFields((err: any, values: any) => {
      //   if (!err) {
      //     const id_list = this.select_row_data.map((item: any) => item.id);
      //     switch (this.more_id) {
      //       case 1:
      //         this.moreChange(id_list, 'charge_teacher_id', values.second);
      //         break;
      //       case 2:
      //         this.moreChange(id_list, 'teacher_id', values.second);
      //         break;
      //       case 3:
      //         this.moreChange(id_list, 'follow_status', values.second);
      //         break;
      //       case 4:
      //         this.moreChange(id_list, 'classes', values.class);
      //         break;
      //       case 5: {
      //         const visit_time = values.visitTime ? Math.floor((values.visitTime as any).format('x') / 1000) : '';
      //         this.moreChange(id_list, 'visit_time', visit_time);
      //         break;
      //       }
      //       case 6: {
      //         const id = values.tag.pop();
      //         this.moreChange(id_list, 'tag', id);
      //         break;
      //       }
      //     }
      //     this.show_add_tag = false;
      //     this.more_id = -1;
      //   }
      // });
    }
    if (this.button_type === 5) {
      if (this.tag_value.length === 0) {
        this.$message.error('请选择标签');
        return;
      }
      const value = this.tag_value.pop();
      this.editDetail('tag', value, this.user);
      this.show_add_tag = false;
    }
  }

  //编辑班主任备注
  async addLog(id: any, index: number) {
    if (!this.log[index]) {
      return;
    }
    const send_data = {
      user_id: id,
      content: this.log[index]
    };
    const res: any = await this.$axios.post(`${API.change_log}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.search(this.table_data.current);
      this.log[index] = '';
    }
  }
  @Watch('teacher_list')
  change(newVal: any) {
    this.filter_teacher = newVal;
  }
  hanleSearch(value: string) {
    if (!value) {
      this.filter_teacher = this.teacher_list;
      return;
    }
    this.filter_teacher = this.teacher_send_list;
    this.$forceUpdate();
  }
  // 格式化
  formatMobile(phone: any) {
    phone = '' + phone;
    const tel = phone.substr(0, 3) + '****' + phone.substr(7);
    return tel;
  }
  // 清空搜索条件
  initSearchMsg() {
    this.form = initForm();
    console.log(this.follower_list);
  }
  //显示导入弹框
  showExportModal() {
    this.stop_tag = 1;
    this.button_type = 1;
    this.show_export_modal = true;
    this.import_branch = -1;
    this.import_type = -1;
    this.export_info_type = 0;
  }
  // 批量修改弹框
  changeMore() {
    if (this.select_row_data.length === 0) {
      this.$message.error('请先勾选要批量修改的用户');
      return;
    }
    this.button_type = 3;
    this.more_id = -1;
    this.show_add_tag = true;
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  //分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  //翻页
  changePage(page: any) {
    this.search(page.current);
  }
  //搜索
  async search(page = 1) {
    this.is_loading = true;
    let start_time = this.form.register_time[0] ? Math.floor((this.form.register_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.form.register_time[1] ? Math.floor((this.form.register_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    const visit_start_time = this.form.back_time[0] ? Math.floor((this.form.back_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const visit_end_time = this.form.back_time[1] ? Math.floor((this.form.back_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
    let start_admission_date = this.form.admission_date[0] ? Math.floor((this.form.admission_date[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_admission_date = this.form.admission_date[1] ? Math.floor((this.form.admission_date[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    let start_expiration = this.form.expiration[0] ? Math.floor((this.form.expiration[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_expiration = this.form.expiration[1] ? Math.floor((this.form.expiration[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    let start_add = this.form.add_time[0] ? Math.floor((this.form.add_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_add = this.form.add_time[1] ? Math.floor((this.form.add_time[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    const income_range_begin = this.form.income_range_begin ? Math.floor(this.form.income_range_begin as any) * 10000 : 0;
    const income_range_end = this.form.income_range_end ? Math.floor(this.form.income_range_end as any) * 10000 : 99999999999;

    let back_status = '';
    if (this.form.tag) {
      this.form.tag.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
    }
    if (this.form.tag_ai) {
      this.form.tag_ai.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
    }
    if (this.form.tag_chaung) {
      this.form.tag_chaung.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
    }
    back_status = back_status.replace(/undefined,/g, '');
    back_status = Array.from(new Set(back_status.split(',').filter(Boolean))).join(',');
    const send_data = {
      is_turning: this.form.special_export ? 1 : 0,
      name: this.form.name ? this.form.name : '',
      mobile: this.form.mobile ? this.form.mobile : '',
      branch_id: this.form.branch_id ? this.form.branch_id : '',
      charge_teacher_id: this.form.charge_teacher_id.length === 0 ? '' : this.form.charge_teacher_id.join(','),
      classes: this.form.classes ? this.form.classes : '',
      online_status: this.form.online_status ? this.form.online_status : '',
      offline_status: this.form.offline_status ? this.form.offline_status : '',
      create_time_start: start_time,
      create_time_end: end_time,
      cooperation: this.form.cooperation[0] ? this.form.cooperation[0] : '',
      cooperation_sub: this.form.cooperation[1] ? this.form.cooperation[1] : '',
      identity: this.form.identity ? this.form.identity : '',
      // tag_id: this.form.tag[0] === 0 ? '' : this.form.tag[this.form.tag.length - 1],
      tag_id: back_status == 'undefined,' || back_status == 'undefined,undefined,' ? '' : back_status,
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      visit_time_start: visit_start_time,
      visit_time_end: visit_end_time,
      is_export: 0,
      log: this.form.follow_msg ? this.form.follow_msg : '',
      current: page,
      limit: 20,
      teacher_id: this.form.class_teacher_id,
      entered_time_start: start_admission_date,
      entered_time_end: end_admission_date,
      expired_time_start: start_expiration,
      expired_time_end: end_expiration,
      add_time_start: start_add,
      add_time_end: end_add,
      training_need: this.form.demand,
      training_needs: this.form.training_needs.join(','),
      corp_name: this.form.corp_name,
      corp_position: this.form.corp_position,
      corp_industry: this.form.industry,
      corp_intro: this.form.corp_intro,
      is_keyman: this.form.is_keyman === 100 ? '' : this.form.is_keyman,
      income_range_begin,
      income_range_end,
      tag_logic: this.form.tag_logic
    };
    // const url = getUrl(API.get_list, send_data);
    const url = `${API.get_list}?${qs.stringify(send_data)}`;
    const res: any = await this.$axios(url);
    if (res.status !== 200) {
      this.$message.error('获取失败');
      this.is_loading = false;
      return;
    }
    this.table_data = res.data.data ? res.data.data : [];
    this.is_loading = false;
    this.select_row_key = [];
  }
  // 录入
  record() {
    this.button_type = 2;
    this.validate_map = validateMapFormat();
    this.validate_student_map = validateStudentMapFormat();
    this.validate_company_map = validateCompanyMapFormat();
    this.exportType = initExportType();
    this.more_change_form.resetFields();
    this.show_export_modal = true;
    this.company_id = Symbol();
    this.contact_type = 0;
    this.is_keyman = 1;
    this.export_input_is_disabled = true;
  }
  //修改导入分社
  changeBranch(value: any) {
    this.import_branch = value;
    this.branch_validate.status = '';
    this.branch_validate.help = '';
  }

  // 修改导入模版
  changeExportType(value: any) {
    this.import_type = value;
    this.type_validate.status = '';
    this.type_validate.help = '';
  }
  // 显示添加标签弹框
  addTag(record: any, type: number) {
    this.tag_value = [];
    this.button_type = 5;
    this.user = record;
    this.show_add_tag = true;
    this.tag_type = type;
  }
  // 下载模版弹框
  downloadTemplate() {
    this.import_type = -1;
    this.button_type = 4;
    this.show_add_tag = true;
  }
  //导入数据
  // leadData(){

  // }
  // 确认导入、录入
  async submitImport() {
    // if (this.exportType.page_type === 1) {
    //   this.company_id = Symbol();
    //   this.contact_type = 0;
    //   this.is_keyman = 1;
    // }

    // console.log(this.button_type)
    // if(this.teacher_widthout_all) {
    //   return;
    // }
    const reg = /^1[3|4|5|7|8|9][0-9]{9}$/;
    console.log(this.button_type);
    if (this.button_type === 2) {
      if (this.exportType.page_type === 2) {
        let is_valid = true;
        if (!this.validate_map.full_name.value) {
          this.validate_map.full_name.status = 'error';
          this.validate_map.full_name.help = '请输入企业名称';
          is_valid = false;
        }
        if (this.validate_map.present_head_id.value.length == 0) {
          this.validate_map.present_head_id.status = 'error';
          this.validate_map.present_head_id.help = '请选择跟进人';
          is_valid = false;
        }
        if (!is_valid) {
          return;
        }

        // if () {

        // }
        // const send_data = {
        //   is_all: 0, //默认分页，传1表示不分页
        //   current: 1,
        //   is_export: 0, //是否导出
        //   limit: 10,
        //   full_name: this.validate_map.relevance_company_id.value,
        //   location: '',
        //   industry: '',
        //   employees_number_floor: '',
        //   employees_number_ceil: '',
        //   cooperation_state: '',
        //   college: '',
        //   is_tob: '',
        //   remark: '',
        //   user_mobile: '',
        //   order_count: '',
        //   begin_start_time: [],
        //   finish_start_time: [],
        //   present_head_id: '',
        //   follow_up_content: '',
        // }
        // const url = getUrl(API.serch_list, send_data);
        // const res: any = await this.$axios.get(url);
        // if (!res.data.data.detail.length) {
        //   this.validate_map.relevance_company_id.status = 'error';
        //   this.validate_map.relevance_company_id.help = '企业不存在';
        //   return
        // }
        const send_data = {
          full_name: this.validate_map.full_name.value,
          is_tob: this.validate_map.is_tob.value,
          present_head_id: this.validate_map.present_head_id.value
          // present_head: this.follower_list.filter((e: any) => e.id === this.validate_map.present_head_id.value)[0].weixin_nickname
        };
        const res_post: any = await this.$axios.post(API.post_company, send_data);
        if (res_post.data.status === 200) {
          this.company_id = res_post.data.data.id;
          this.exportType.page_type = 1;
        } else {
          this.validate_map.full_name.status = 'error';
          this.validate_map.full_name.help = '企业已存在';
        }
        return;
      }
      // 学员录入
      if (this.exportType.page_type !== 2) {
        let is_valid = true;
        if (this.exportType.input_type === 1) {
          if (!this.validate_student_map.branch_id.value) {
            this.validate_student_map.branch_id.status = 'error';
            this.validate_student_map.branch_id.help = '请选择分社';
            is_valid = false;
          }
          if (!this.validate_student_map.username.value) {
            this.validate_student_map.username.status = 'error';
            this.validate_student_map.username.help = '请输入姓名';
            is_valid = false;
          }
          if (!reg.test(this.validate_student_map.phone.value)) {
            this.validate_student_map.phone.status = 'error';
            this.validate_student_map.phone.help = '请输入正确的手机号';
            is_valid = false;
          }
        }
        if (this.exportType.input_type === 2) {
          if (!this.validate_company_map.branch_id.value) {
            this.validate_company_map.branch_id.status = 'error';
            this.validate_company_map.branch_id.help = '请选择分社';
            is_valid = false;
          }
          if (!this.validate_company_map.username.value) {
            this.validate_company_map.username.status = 'error';
            this.validate_company_map.username.help = '请填写姓名';
            is_valid = false;
          }
          if (!this.validate_company_map.contact_type.value) {
            this.validate_company_map.contact_type.status = 'error';
            this.validate_company_map.contact_type.help = '请选择联系方式';
            is_valid = false;
          }
          if (!this.validate_company_map.wechat.value && this.validate_company_map.contact_type.value === 2) {
            this.validate_company_map.wechat.status = 'error';
            this.validate_company_map.wechat.help = '请填写微信';
            is_valid = false;
          }
          if (!reg.test(this.validate_company_map.phone.value) && this.validate_company_map.contact_type.value === 1) {
            this.validate_company_map.phone.status = 'error';
            this.validate_company_map.phone.help = '请输入正确的手机号';
            is_valid = false;
          }
        }
        console.log(this.validate_company_map);
        console.log(is_valid);
        if (!is_valid) {
          return;
        }
        const send_data: any = {
          name: this.exportType.input_type === 1 ? this.validate_student_map.username.value : this.validate_company_map.username.value,
          mobile: this.exportType.input_type === 1 ? this.validate_student_map.phone.value : this.validate_company_map.phone.value,
          branch_id: this.exportType.input_type === 1 ? this.validate_student_map.branch_id.value : this.validate_company_map.branch_id.value,
          connect_type: this.validate_company_map.contact_type.value ? this.validate_company_map.contact_type.value : undefined,
          wechat: [this.validate_company_map.wechat.value],
          charge_teacher_id: this.exportType.input_type === 1 ? this.validate_student_map.charge_teacher_id.value : this.validate_company_map.charge_teacher_id.value,
          teacher_id: this.exportType.input_type === 1 ? this.validate_student_map.user_teacher_id.value : this.validate_company_map.user_teacher_id.value,
          company_id: this.exportType.input_type === 2 ? this.company_id : undefined,
          is_keyman: this.exportType.input_type === 2 ? this.validate_company_map.is_keyman.value : undefined,
          input_type: this.exportType.input_type
        };
        send_data.charge_teacher_id = send_data.charge_teacher_id.length === 0 ? 0 : send_data.charge_teacher_id;
        // this.validate_student_map.charge_teacher_id.value
        //   ? (send_data.charge_teacher_id = this.validate_student_map.charge_teacher_id.value)
        //   : '';
        // this.validate_student_map.user_teacher_id.value
        //   ? (send_data.teacher_id = this.validate_student_map.user_teacher_id.value)
        //   : '';
        console.log(send_data);
        console.log(_.pickBy(send_data));
        const res: any = await this.$axios.post(API.get_list, send_data);
        if (res.data.status === 200) {
          this.$message.success('录入成功');
          this.show_export_modal = false;
          this.search(this.table_data.current);
        } else {
          this.$message.error(res.data.message);
        }
      }
    }

    // if (this.exportType.input_type === 2) {

    // }

    if (this.button_type === 1) {
      let is_submit = true;
      if (this.import_branch === -1) {
        this.branch_validate.status = 'error';
        this.branch_validate.help = '导入分社必填';
        is_submit = false;
      }
      if (this.import_type === -1) {
        this.type_validate.status = 'error';
        this.type_validate.help = '导入模版必填';
        is_submit = false;
      }
      if (!is_submit) {
        return;
      }
      if (this.file_list.length === 0) {
        this.$message.error('请选择文件上传');
        return;
      }
      const header_list = Object.keys(this.input_data[0]);
      header_list.forEach((item: any, index: number) => {
        if (!item || item === '__EMPTY') {
          header_list.splice(index, 1);
        }
      });
      if (this.import_type === 2) {
        if (header_list.length !== 17) {
          this.input_data = [];
          this.file_list = [];
          this.$message.error('请选择格式正确的文件上传');
          return;
        }
        for (const obj in header_list) {
          if (branch_prd.indexOf(obj) !== -1) {
            this.input_data = [];
            this.file_list = [];
            this.$message.error('请选择格式正确的文件上传');
            return;
          }
        }
      }
      if (this.import_type === 1) {
        if (header_list.length !== 14) {
          this.input_data = [];
          this.file_list = [];
          this.$message.error('请选择格式正确的文件上传');
          return;
        }
        for (const obj in header_list) {
          if (extra_prd.indexOf(obj) !== -1) {
            this.input_data = [];
            this.file_list = [];
            this.$message.error('请选择格式正确的文件上传');
            return;
          }
        }
      }
      const send_data = {
        template_type: this.import_type
      };
      console.error(send_data);

      const res: any = await this.$axios.post(API.create_task, send_data);
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.task_id = res.data.data.task_id;
      this.confirm_loading = true;
      this.moreUpload(0, 0, this.import_type, this.import_branch, this.task_id);
    } else {
      //   this.more_change_form.validateFields(async (err: any, values: any) => {
      //     if (!err) {
      //       const send_data: any = {
      //         name: values.username,
      //         mobile: values.phone,
      //         branch_id: values.branch_id,
      //         connect_type: values.connect_type,
      //         wechat:[values.wechat],
      //         charge_teacher_id: values.charge_teacher_id,
      //         teacher_id: values.user_teacher_id,
      //         company_id: this.company_id,
      //         is_keyman: this.is_keyman,
      //         input_type: this.exportType.input_type,
      //       };
      //       values.charge_teacher_id
      //         ? (send_data.charge_teacher_id = values.charge_teacher_id)
      //         : '';
      //       values.user_teacher_id
      //         ? (send_data.teacher_id = values.user_teacher_id)
      //         : '';
      //       const res: any = await this.$axios.post(API.get_list, send_data);
      //       if (res.data.status === 200) {
      //         this.$message.success('录入成功');
      //         this.show_export_modal = false;
      //         this.search(this.table_data.current);
      //       } else {
      //         this.$message.error(res.data.message);
      //       }
      //     }
      //   });
    }
  }
  //导出
  async exportData() {
    try {
      let start_learning = this.form.add_time[0] ? Math.floor((this.form.add_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      let end_learning = this.form.add_time[1] ? Math.floor((this.form.add_time[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    } catch (error) {
      console.log(error);
    }
    const start_time = this.form.register_time[0] ? Math.floor((this.form.register_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.form.register_time[1] ? Math.floor((this.form.register_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    const visit_start_time = this.form.back_time[0] ? Math.floor((this.form.back_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const visit_end_time = this.form.back_time[1] ? Math.floor((this.form.back_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    let start_admission_date = this.form.admission_date[0] ? Math.floor((this.form.admission_date[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_admission_date = this.form.admission_date[1] ? Math.floor((this.form.admission_date[1] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    let start_expiration = this.form.expiration[0] ? Math.floor((this.form.expiration[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_expiration = this.form.expiration[1] ? Math.floor((this.form.expiration[1] as any).hours(23).minutes(59).seconds(59) / 1000) : '';
    let stat_add = this.form.add_time[0] ? Math.floor((this.form.add_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    let end_add = this.form.add_time[1] ? Math.floor((this.form.add_time[1] as any).hours(0).minutes(0).seconds(0) / 1000) + 86400 : '';
    const income_range_begin = this.form.income_range_begin ? Math.floor(this.form.income_range_begin as any) * 10000 : 0;
    const income_range_end = this.form.income_range_end ? Math.floor(this.form.income_range_end as any) * 10000 : 99999999999;
    console.log(stat_add);
    console.log(end_add);

    /*     let tag_id = '';
    if (this.form.tag) {
      this.form.tag.forEach((element: any) => (tag_id += element[element.length - 1] + ','));
    } */

    let back_status = '';
    if (this.form.tag) {
      this.form.tag.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
      back_status.replace(/undefined,/g, '');
    }
    if (this.form.tag_chaung) {
      this.form.tag_chaung.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
      back_status.replace(/undefined,/g, '');
    }

    const send_data = {
      is_turning: this.form.special_export ? 1 : 0,
      name: this.form.name ? this.form.name : '',
      mobile: this.form.mobile ? this.form.mobile : '',
      branch_id: this.form.branch_id ? this.form.branch_id : '',
      charge_teacher_id: this.form.charge_teacher_id.length === 0 ? '' : this.form.charge_teacher_id.join(','),
      classes: this.form.classes ? this.form.classes : '',
      online_status: this.form.online_status ? this.form.online_status : '',
      offline_status: this.form.offline_status ? this.form.offline_status : '',
      create_time_start: start_time,
      create_time_end: end_time,
      cooperation: this.form.cooperation[0] ? this.form.cooperation[0] : '',
      cooperation_sub: this.form.cooperation[1] ? this.form.cooperation[1] : '',
      identity: this.form.identity,
      // tag_id: tag_id == 'undefined,' ? '' : tag_id.substr(0, tag_id.length - 1),
      tag_id: back_status == 'undefined,' || back_status == 'undefined,undefined,' ? '' : back_status,
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      visit_time_start: visit_start_time,
      visit_time_end: visit_end_time,
      is_export: 1,
      current: 1,
      limit: 50,
      teacher_id: this.form.class_teacher_id,
      entered_time_start: start_admission_date,
      entered_time_end: end_admission_date,
      expired_time_start: start_expiration,
      expired_time_end: end_expiration,
      add_time_start: stat_add,
      add_time_end: end_add,
      training_need: this.form.demand,
      training_needs: this.form.training_needs,
      corp_name: this.form.corp_name,
      corp_position: this.form.corp_position,
      corp_industry: this.form.industry,
      corp_intro: this.form.corp_intro,
      is_keyman: this.form.is_keyman === 100 ? '' : this.form.is_keyman,
      log: this.form.follow_msg ? this.form.follow_msg : '',
      income_range_begin,
      income_range_end,
      tag_logic: this.form.tag_logic
    };

    console.log(send_data);
    // const url = getUrl(API.get_list, send_data);
    // const url = getUrl(API.get_list, send_data);
    const url = `${API.get_list}?${qs.stringify(send_data)}`;
    this.$axios.get(url).then((res) => {
      if (res.data.status === 500) {
        this.$message.error(res.data.message);
      } else {
        console.log(this.form.tag);

        window.location.href = url;
      }
    });
  }
  //确认取消上传
  confirmStopUpload() {
    this.show_stop_modal = false;
    this.stop_tag = -1;
    this.input_data = [];
    this.file_list = [];
    this.confirm_loading = false;
    this.import_branch = -1;
    this.import_type = 1;
    this.show_export_modal = false;
  }
  // 取消所有弹框数据清空,关闭所有弹框统一调用
  cancel() {
    if (this.button_type === 1 && this.confirm_loading) {
      this.show_stop_modal = true;
      this.stop_tag = 1;
      return;
    }
    this.record_validate.username_validate.status = 'success';
    this.record_validate.username_validate.help = '';
    this.record_validate.phone_validate.status = 'success';
    this.record_validate.phone_validate.help = '';
    this.import_type = -1;
    this.import_branch = -1;
    this.show_export_modal = false;
    this.input_data = [];
    this.confirm_loading = false;
    this.file_list = [];
    this.show_add_tag = false;
  }
  //删除标签
  async deleteTag(id: number) {
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
      return;
    }
  }
  onSelectChange(select_row_key: any, value: any) {
    this.select_row_data = value;
    this.select_row_key = select_row_key;
  }
  check(record: any) {
    this.$router.push(`/hundun/user-detail/${record.id}?menu_id=${this.window.route_menu_id}`);
    console.log(record);
  }
  async getUserList() {
    this.is_loading = true;
    const res: any = await this.$axios.get(API.get_list, {
      params: { limit: 20, is_export: 0 }
    });
    if (res.status !== 200) {
      this.$message.error('获取失败');
      this.is_loading = false;
      return;
    }
    this.table_data = res.data.data ? res.data.data : [];
    this.is_loading = false;
  }
  beforeCreate() {
    this.more_form = this.$form.createForm(this);
    this.more_change_form = this.$form.createForm(this);
  }
  async initFollower() {
    const send_data = {
      current: 1,
      limit: 999999,
      weixin_nickname: '',
      mobile: '',
      charge: '',
      status: 0
    };
    const url = getUrl(API.get_follower_list, send_data);
    const res: any = await this.$axios.get(url);
    this.follower_list = res.data.data
      ? [
          {
            id: 0,
            weixin_nickname: '全部'
          },
          ...res.data.data.detail
        ]
      : [
          {
            id: 0,
            weixin_nickname: '全部'
          }
        ];
  }
  focusUserInfo() {
    this.export_input_is_disabled = true;
  }
  changeInputType(values: any) {
    this.exportType.page_type = this.exportType.input_type = values.target.value;
    this.validate_student_map = validateStudentMapFormat();
    this.validate_company_map = validateCompanyMapFormat();
  }

  async checkUserInfo(values: any) {
    const send_data = {
      connect_type: this.validate_company_map.contact_type.value,
      connect_value: values.target.value
    };
    const res: any = await this.$axios.get(`${API.serch_detailInfo}?${qs.stringify(send_data)}`);
    if (res.data.data) {
      this.validate_company_map.branch_id.value = res.data.data.branch_id;
      this.validate_company_map.username.value = res.data.data.name;
      this.validate_company_map.charge_teacher_id.value = res.data.data.charge_teacher_id ? res.data.data.charge_teacher_id : '';
      this.validate_company_map.user_teacher_id.value = res.data.data.user_teacher.map((item: any) => item.teacher_id);
      this.export_input_is_disabled = true;
    } else {
      this.export_input_is_disabled = false;
    }
  }
  // 关联企业
  async connectCompany(id: number) {
    this.connect_company_visible = true;
    if (id == 0) return (this.relevance_list = []);
    const send_data = { company_id: id, current: 1, limit: 999 };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios(url);
    if (res.data.status !== 200) return this.$message.error('查看关联企业失败！');
    this.relevance_list = res.data.data.detail;
  }
  getFollowStatus(val: any) {
    let str = '';
    if (val) {
      val.forEach((item: any) => {
        const name = this.follow_status_without_all.find((val: any) => val.id == item)?.value;
        if (name) str = str + ', ' + name;
      });
    }
    return str.slice(1) || '-';
  }

  created() {
    this.getTeacher();
    this.teacher_send_list = this.teacher_list.slice(1);
    this.filter_teacher = this.teacher_list;
    this.branch_list = this.branch_office.slice(1);
    this.getTags();
    this.getUserList();
    this.initFollower();
  }
}
